<script setup lang="ts">
withDefaults(defineProps<{size?: number}>(), {size: 32});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="AIL Tutor"
    width="507"
    height="507"
    viewBox="0 0 507 507"
    preserveAspectRatio="xMidYMid meet"
    class="text-gray-900 dark:text-white"
    :style="{ width: `${size}px`, height: `${size}px` }"
  >
    <g
      transform="translate(0.000000,507.000000) scale(0.100000,-0.100000)"
      fill="currentColor"
      stroke="none"
    >
      <path
        d="M2021 3712 c-662 -1164 -1674 -2943 -1766 -3104 l-73 -128 182 0 182
0 70 122 c39 68 328 571 644 1118 315 547 668 1159 783 1360 116 201 315 547
444 769 128 222 233 407 233 412 0 7 -177 317 -189 331 -3 4 -233 -392 -510
-880z"
      />
      <path
        d="M2699 4018 c-47 -68 -89 -128 -92 -135 -4 -6 426 -765 967 -1705
l973 -1693 177 -3 c97 -1 176 0 176 3 0 3 -68 124 -152 268 -1424 2463 -1951
3373 -1957 3380 -4 4 -45 -48 -92 -115z"
      />
      <path
        d="M2729 2834 c-52 -75 -93 -141 -91 -147 3 -9 692 -1179 794 -1346 21
-34 38 -65 38 -67 0 -2 -182 -5 -404 -6 l-403 -3 66 -142 66 -142 608 -1 c335
0 606 3 604 8 -12 21 -1180 1977 -1182 1980 -1 1 -44 -59 -96 -134z"
      />
      <path
        d="M2337 2068 c-107 -183 -224 -384 -261 -445 l-65 -113 529 0 529 0
-265 443 c-146 243 -267 443 -269 445 -1 1 -90 -147 -198 -330z m269 -127 c55
-25 87 -71 92 -136 13 -152 -170 -233 -275 -122 -61 64 -64 149 -8 215 51 61
119 76 191 43z"
      />
      <path
        d="M846 614 c-42 -69 -76 -127 -76 -130 0 -2 292 -4 648 -4 l649 0 61
130 61 130 -634 0 -634 0 -75 -126z"
      />
      <path
        d="M2954 648 c24 -51 51 -110 61 -130 l19 -38 638 0 c351 0 638 3 638 8
-1 4 -33 61 -74 127 l-72 120 -627 3 -626 2 43 -92z"
      />
    </g>
    <g
      transform="translate(0.000000,507.000000) scale(0.100000,-0.100000)"
      fill="#2ec4c8"
      stroke="none"
    >
      <path
        d="M2448 3333 c-41 -71 -216 -369 -388 -663 -619 -1057 -952 -1626 -972
-1658 l-20 -32 617 0 616 0 68 143 67 142 -398 5 -398 5 540 929 c335 576 538
936 535 945 -11 28 -180 311 -186 311 -4 0 -40 -57 -81 -127z"
      />
    </g>
  </svg>
</template>
